import TransactionList from 'common/pages/transactions/TransactionList.tsx'

export const TransactionListAgency = (props: any) => <TransactionList {...props} agency />